import decode from 'jwt-decode';
import { Barra } from '../constants';

/**
* Verficar la caducidad del token
* 
*/
export const checkToken = () => {
    return  (localStorage.getItem('token') !== null) && decode(localStorage.getItem('token')).exp > Date.now() / 1000;
}

export const getSegmento = () => {
    return parseInt(localStorage.getItem('segmento')) || null
}

export const esBarras = () => {
    const segmento = getSegmento()
    return segmento != null && segmento === Barra 
}